import { Link } from 'react-router-dom';
import { groupBy, map, sortBy, keys, size, pickBy } from 'lodash';
import { useContainer } from 'unstated-next';
import { SelectedRecipes } from '../stateContainers';
import { Recipe, recipes } from '../data/';
import { List, Menu, Button, Header } from 'semantic-ui-react';
import { FormattedIngredient } from './FormatIngredient';
import { FixedFooter } from './FixedFooter';

export const Ingredients = () => {
    const { selectedRecipes } = useContainer(SelectedRecipes);
    const ingredientsByName = groupBy(
        Object.keys(pickBy(selectedRecipes, (value) => value === true))
            // @ts-ignore
            .map((selectedRecipe) => recipes[selectedRecipe])
            .flatMap((recipe: Recipe) => {
                return recipe.ingredients.flatMap((ingredientDetails) => {
                    return ingredientDetails.materials;
                });
            }),
        'name',
    );

    return (
        <>
            <Header as="h1">Recipes</Header>
            {sortBy(keys(ingredientsByName), (ingredientName) => ingredientName.toLowerCase()).map(
                (recipeName) => {
                    return (
                        <>
                            <h2>{recipeName}</h2>
                            <List>
                                {map(ingredientsByName[recipeName], (ingredient, idx) => {
                                    return (
                                        <List.Item key={idx}>
                                            <FormattedIngredient {...ingredient} />
                                        </List.Item>
                                    );
                                })}
                            </List>
                        </>
                    );
                },
            )}
            <FixedFooter className="ui two buttons">
                <Button size="large" as={Link} fluid to="/">
                    Back
                </Button>
            </FixedFooter>
        </>
    );
};
